interface RatingStarsProps {
  value: number;
  max?: number;
  className?: string;
}

export default function RatingStars({ value, max = 5, className = "" }: RatingStarsProps) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`评分 ${value} 分，满分 ${max} 分`}>
      {Array.from({ length: max }).map((_, index) => (
        <i
          key={index}
          className={
            index < Math.round(value)
              ? "ri-star-fill text-accent-500 text-sm leading-none"
              : "ri-star-line text-foreground-300 text-sm leading-none"
          }
          aria-hidden="true"
        />
      ))}
    </span>
  );
}